import React, { Fragment } from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';
import ProductConfig from '../../../src/config/ProductConfig.json';

// ES6 class-style
class sg_Footer extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			ProductList: [],
			pro_detail: [],
			products: [],
			self: [],
			plp: [],
			products_details: {},
			products_category_order: []
		};
		this.grades = this.props.grades;
		this.productClass = this.props.products_class;
		this.productDetails = this.props.products_details;
		this.products_category = this.props.products_category;
		this.productClasses = this.props.classes;
		this.state.products = (Object.keys(this.products_category));
		this.renderFooterProduct = this.renderFooterProduct.bind(this);
		this.restricted = false;

		this.userObj = null;
		this.restrictedCategories = window.footerRestrictedProdCategories || [];
	}

	componentDidMount() {
		//console.warn("SG Footer");
		const { products, self, plp } = this.state;
		this.grades = this.props.grades;
		this.productClass = this.props.products_class;
		this.productDetails = this.props.products_details;
		this.products_category = this.props.products_category;
		this.productClasses = this.props.classes;
		this.state.products = (Object.keys(this.products_category));

		//HmEventRegistry.fireEvent("INITIATE_GA");

	}
	componentDidUpdate() {
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

	getProdDetails() {
		//console.log(this.state.products_details);
		if (this.state.products_details !== {} && this.state.products_details !== undefined) {
			return this.state.products_details;
		}
	}

	saveID(grade, proID, link) {
		const { products_details } = this.state;
		var me = this;
		var callBackSuccess = function (result) {
			if (result !== null) {

				me.setState({
					products_details: result
				}),
					//console.log("Footer:::",me.getProdDetails());
					localStorage.setItem('grade', grade);
				localStorage.setItem('product', proID);
				localStorage.setItem('proDetail', JSON.stringify(me.getProdDetails()));

				window.top.location.href = link;

			}

			//console.log("response : ", response);
		}

		var callBackFailure = function (response) {
			me.setState({
				isLoaded: true,
				error: "Error in Footer PRODUCT_JSON"
			});
			console.log("Error in Footer PRODUCT_JSON in Grade");
		}

		var formData = {
			"levelId": grade
		}
		new HmAjax(this.getUrlFor("PRODUCT_JSON"), formData).post(callBackSuccess, callBackFailure);

		//console.log(grade);
		//console.log(proID);

	}

	renderFooterProduct(product, grade) {
		//console.log(product,", ",grade,", ",this.productClasses);
		if (product && grade && this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grade)) {
			var restricted = ""
			if (this.GradeRestrictionManager.isGradeRestricted(grade)) {
				restricted = "restricted";
				this.restricted = true;
			}

			if (ProductConfig[product]) {
				return (<li className={restricted} key={grade} data-ga={'Footer - ' + ProductConfig[product].ganame + ' - ' + this.productClasses[grade].ClassName} onClick={() => this.saveID(`${grade}`, `${this.products_category[product][grade]}`, ProductConfig[product].url + this.products_category[product][grade])}>
					{this.productClasses[grade].ClassName}
					{(() => {
						if (restricted == "restricted") {
							return "*";
						}
					})()}
				</li>);
			}
		}
	}

	checkRestrictedGrade(product, grades) {
		//console.log("grades:::",grades, ", ",product);
		//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
		var restrictedAvailable = false;
		var restrictedGrades = [];

		if (grades && grades.length > 0) {
			for (var i = 0; i < grades.length; i++) {
				if (this.products_category && this.products_category[product] && this.products_category[product].hasOwnProperty(grades[i])) {
					if (this.GradeRestrictionManager.isGradeRestricted(grades[i])) {
						restrictedGrades.push(grades[i]);
					}
				}
			}

			try {
				restrictedAvailable = (restrictedGrades.length === Object.keys(this.products_category[product]).length);
			} catch (e) { }

		} else { restrictedAvailable = true; }

		return restrictedAvailable;
	}

	getUserRole() {
		var role = '';
		if (this.UserStore) {
			if (this.getUser() && this.getUser().get()) {
				role = this.getUser().get().userRole.role;
			}
		}
		//console.log("role ",role);
		return role;
	}

	geoBasedProductHeader = () => {
		let me = this;
		if (this.prodForCountry() === 'IN') {
			return me.renderProductTab();

		} else if (this.prodForCountry() === 'SG') {
			return me.SgCatalogue();
		} else {
			return (
				<Fragment>
					{me.renderProductTab()}
					{me.SgCatalogue()}
				</Fragment>)
		}
	}

	renderProductTab() {
		let geoLocation = this.getGeo().toUpperCase() || '';
		if (this.getUserRole() == "TCHR" && geoLocation === 'IN') {
			return (
				<li></li>
			)
		} else {
			return (
				<span>
					<li data-ga="Footer - Products" ><Link to="/in/products">{this.rb("in.products.students.title")}</Link></li>
					<li data-ga="Footer - Products" ><Link to="/sg/products">{this.rb("sg.products.title")}</Link></li>
				</span>
			)
		}
	}

	renderTeacherTab() {
		if (window.teachers_tab_suppressed) {
			return (<li></li>);
		}


		if (this.getUserRole() == "STU") {
			return (
				<li></li>
			)
		} else {
			return (
				<li data-ga="Footer - Teachers" ><Link to="/teachers">Teachers</Link></li>
			)
		}
	}

	SgCatalogue() {
		return (
			<li data-ga="Footer - SgCatalogue" ><Link to="/sg/products">{this.rb("sg.products.title")}</Link></li>
		)
	}

	getFooterProduct = (product) => {
		let me = this;
		if (this.prodForCountry() !== 'SG') {
			return (
				<Fragment>
					<h5>{me.rb(product)}</h5>
					<ul className="Lessons-links">
						{me.grades.map(grade => (
							me.renderFooterProduct(product, grade)
						))}
					</ul>
				</Fragment>
			)
		}
	}

	renderLessonsTab() {
		var me = this;
		if (me.getUserRole() != "TCHR") {
			return (me.state.products_category_order.map(product => {
				//if(this.checkRestrictedGrade(product,this.grades) == false){
				if ((!me.restrictedCategories || me.restrictedCategories.length === 0) || (me.restrictedCategories.length > 0 && me.restrictedCategories.indexOf(product) < 0)) {
					return (
						<div className="col-12 col-md-3 no-padding" key={product}>

							{/* {console.warn("lalala prod: ", this.products_category[product], product, this.products_category)} */}



							{this.getFooterProduct(product)}

						</div>
					);
				}

			})
			)
			//}
		}
	}

	render() {
		let telPhoneNo = window.telPhoneNo[this.getGeo()] || window.telPhoneNo['OTHERS'] || '+91 44 3500 2073';
		const { products, self, plp } = this.state;
		this.grades = this.props.grades;
		this.grades_order = this.props.grades_order;
		this.productClass = this.props.products_class;
		this.productDetails = this.props.products_details;
		this.products_category = this.props.products_category;
		this.productClasses = this.props.classes;
		this.state.products = (Object.keys(this.products_category));
		this.state.products_category_order = this.props.products_category_order;
		const tifOptions = [];

		return (
			<footer>
				<div className="container">
					<div className="row grade-links">
						<div className="col-12 col-md-3">
							<ul className="f-links atag">

								<li data-ga="Footer - Home" ><Link to="/">Home</Link></li>
								{this.SgCatalogue()}
								{/* {this.renderTeacherTab()} */}
								<li data-ga="Footer - Who we are" ><Link to="/who-we-are">Who We Are</Link></li>
								<li data-ga="Footer - Our Learnings"><Link to="/our-learnings">Our Learnings</Link></li>
								<li data-ga="Footer - Spotlight" ><Link to="/spotlight">Spotlight</Link></li>
								<li data-ga="Footer - FAQ" ><Link to="/faq">{this.rb("FAQ")}</Link></li>
							</ul>
						</div>
						{this.renderLessonsTab()}

					</div>
					<div className="row follow-us">
						<div className="col-lg-4 col-md-5 no-padding">
							<div className="follow">
								<p>Follow us on</p>
								<ul>
									<li><a data-ga="Footer - Follow Us - Facebook" href="https://www.facebook.com/heymath" target="_blank"><i className="fab fa-facebook-f"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Twitter" href="http://twitter.com/heymath" target="_blank"><i className="fab fa-twitter"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Linkedin" href="http://linkedin.com/company/heymath" target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Youtube" href="http://bit.ly/HeyMathYouTube" target="_blank"><i className="fab fa-youtube"></i></a></li>
									<li><a data-ga="Footer - Follow Us - Instagram" href="https://www.instagram.com/heymath_india/" target="_blank"><i className="fab fa-instagram"></i></a></li>
								</ul>
							</div>
						</div>
						<div className="col-lg-4 col-md norightpadding">
							<div className="text-link text-left">
								<a data-ga="Footer - Phone number" href={"tel:" + telPhoneNo}><img src="../img/tel.png" alt="" /> {telPhoneNo}</a>
							</div>
							<div className="text-link text-left">
								<a data-ga="Footer - Email ID" href="mailto:support@heymath.com"><img src="../img/mail.png" alt="" /> support@heymath.com</a>
							</div>
						</div>
						<div className="col-lg-4 col-md nopadding">
							<div className="text-link text-center">
								<span data-ga="Footer - Contact Us" className="r-btn contactbtn" onClick={this.props.showContactus}>Contact us</span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4 text-link ">
							<p className="text-left">All rights reserved &copy; {this.rb("footer.copyright.year")} <strong>HeyMath!</strong> </p>
						</div>
						<div className="col-md-4 text-link">
							<a data-ga="Footer - Terms" href={this.getTermsUrl("SG")} target="_blank"> Terms of Use</a>
							<span>|</span> <a data-ga="Footer - Privacy Policy" href={this.getUrlFor("LUMOS_PRIVACY")} target="_blank"> Privacy Policy</a>
						</div>
						<div className="col-md-4 text-link">
							{/* <p>Designed by <a data-ga="Footer - Leo9" href="http://www.leo9studio.com/" target="_blank"><strong>Leo9 Studio</strong></a></p> */}
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default sg_Footer;



// WEBPACK FOOTER //
// ./src/views/sg/sg_Footer.js